
interface ServiceCardProps {
  title: string;
  description: string;
  link?: string;
  buttonText?: string | null;
  featured?: boolean;
  external?: boolean;
}

export function ServiceCard({ 
  title, 
  description, 
  link, 
  buttonText, 
  featured = false,
  external = false 
}: ServiceCardProps) {
  const handleClick = () => {
    if (link) {
      if (external) {
        window.open(link, '_blank', 'noopener,noreferrer');
      } else {
        window.location.href = link;
      }
    }
  };

  return (
    <div className={`
      bg-white shadow-sm p-6 flex flex-col h-full
      ${featured ? '' : ''}
    `}>
      {/* Icon - using checkmark icon similar to original */}
      <div className="flex justify-center mb-4">
        <div className={`
          w-14 h-14 rounded-full flex items-center justify-center border-2
          ${featured 
            ? 'bg-orange-500 border-orange-500' 
            : 'bg-transparent border-gray-400'
          }
        `}>
          {featured ? (
            <svg className="w-6 h-6 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="20,6 9,17 4,12"/>
            </svg>
          ) : (
            <svg className="w-6 h-6 text-gray-400" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="20,6 9,17 4,12"/>
            </svg>
          )}
        </div>
      </div>
      
      {/* Title */}
      <h3 className="text-lg font-medium text-gray-800 text-center mb-3 leading-tight">
        {title}
      </h3>
      
      {/* Description */}
      <p className="text-gray-600 text-sm text-center mb-6 flex-grow leading-relaxed">
        {description}
      </p>
      
      {/* Button */}
      {buttonText && (
        <button
          onClick={handleClick}
          className={`
            w-full py-3 px-4 text-sm font-medium text-white transition-colors
            ${featured 
              ? 'bg-orange-500 hover:bg-orange-600' 
              : 'bg-blue-800 hover:bg-blue-900'
            }
          `}
        >
          {buttonText}
        </button>
      )}
    </div>
  );
}